import { Injectable, Inject, ErrorHandler } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { ERROR, WARNING } from './error-handler.actions';
import { CLPBPStore } from '../../../store';
import { ErrorHandlerApiService } from '../error-handling-api/error-handler-api.service';
import { Warning } from './error-types';


export interface LoggerErrorHandlerOptions {
  rethrowError: boolean;
  unwrapError: boolean;
  hideConsoleLogs: boolean;
}

export const loggerErrorHandlerOptions = {
  rethrowError: false,
  unwrapError: false,
  hideConsoleLogs: false // todo: change this to true when environment is prod
};

@Injectable()
export class LoggerErrorHandler extends ErrorHandler {
  error: Observable<any>;
  constructor(
    @Inject('LoggerErrorHandlerOptions') private option: LoggerErrorHandlerOptions,
    private errorHandlerApiService: ErrorHandlerApiService,
    private store: Store<CLPBPStore> ) {
    super();
  }

  handleError(error: Error): void {
    if (!this.option.hideConsoleLogs) {
      this.logToConsole(error);
    }

    switch (error.name) {
      case 'Warning':
        this.logToGTM(error, WARNING);
        break;
      default:
        if (error instanceof Error) {
          this.errorHandlerApiService.logToApi(error, ERROR);
          this.logToGTM(error, ERROR);
        }
    }

    // We rethrow exceptions, so operations like 'bootstrap' will result in an errors
    // when an errors happens. If we do not rethrow, bootstrap will always succeed.
    if (this.option.rethrowError) {
      throw error;
    }
  }

  private logToGTM(error: any, type: string = ERROR): void {
    this.store.dispatch({type: type, payload: error});
  }

  private logToConsole(error: any): void {
    try {
      if (error instanceof Warning) {
        console.warn(error);
      } else {
        console.group('ErrorHandler');
        super.handleError(error);
        console.groupEnd();
      }
    } catch (error) {
      console.error('Error when trying to output errors.', error);
    }
  }
}
